import React, {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import moment from 'moment'
import TargetTime from './common/TargetTime'
import {SetPoint} from "../CampaignModel"
import {
    apollo_useStyles, Option,
    options_ms_billing_type,
    options_ms_campaign_type,
    options_select_ms_campaign_type,
    options_state_edit_ms
} from "../../../atom/Apollo_styles";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloMessage} from "../../../atom/Apollo_Mesasge";
import {
    get_ms_campaign_path, hera_account_path,
    hera_setpoints_path,
    isummary_path,
    post_ms_campaign_path,
    put_ms_campaign_path
} from "../../../atom/Apollo_links";
import {APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN, ApolloUserProfileAuth} from "../../../atom/Apollo_Authorization";
import {ApolloBasicDistributionDate, ApolloBasicSelect, ApolloBasicTextField} from "../../../molecule/Apollo_BaseItem";
import {
    ARCHIVE_VALUE_NO,
    BILLING_TYPE,
    BLANK,
    CAMPAIGN_TYPE,
    CREATE_PROC,
    DATE_TIME_SUFFIX,
    DEFAULT_WEEK,
    ENABLE_SCHEDULE_TIMES,
    ENABLE_SCHEDULE_TIMES_MS,
    EDIT_PROC,
    END_DATE_TYPE,
    FORMAT_END_DAY_YYYY_MM_DD_HHmmss,
    FORMAT_START_DAY_YYYY_MM_DD_HHmmss, FORMAT_YYYY_MM_DD,
    FORMAT_YYYY_MM_DD_HHmm,
    INIT_NUMBER,
    INIT_STR,
    MAX_BUDGET_LIMIT_DAILY_AMOUNT,
    MAX_END_DATE,
    MAX_TRACKING_POINTS_NUM,
    MSG,
    RESULT_KBN,
    RESULT_SETPOINT_ERROR
} from "./common/CommonConst";
import {Campaign, CampaignCreate, CampaignUpdate} from "./common/CommonModel";
import {ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";
import {cloneDeep} from "lodash";
import {
    ApolloEventRecord,
    createLogDate,
    createUserLogItemListFromDate,
    createUserLogItemListFromNumber,
    createUserLogItemListFromOptionValue,
    createUserLogItemListFromOptionValuesTrackingMs,
    createUserLogItemListFromSchedules,
    createUserLogItemListFromString,
    ItemList,
    LogData,
    SCHEDULES_WEEKS_MS
} from "../../../atom/Apollo_EventRecord";
import {checkInvalidTabCharsForName, getAccountDeletedSetPoints, getTrackerSetPoint} from "../../../common/Apollo_CommonUtil";
import {ApolloDialog} from "../../../atom/Apollo_Dialog";
import {ApolloConfirmNotActiveDialog} from "../../../organism/HERA/ConfirmNotActiveDialog";

type LogRecord = {
    data: Campaign
}

const scheduleStringToArrayForMs = function (scheduleString: string, campaignType: number) {
    const scheduleArray = JSON.parse(scheduleString)
    const scheduleArrayBoolean = scheduleArray.map((row: any, index: number) => {
        let timeArray: boolean[] = []
        row.forEach((elem: number, index: number) => {
            if (campaignType === CAMPAIGN_TYPE.MS) {
                if (ENABLE_SCHEDULE_TIMES_MS.includes(index)) {
                    timeArray.push(elem === 1 ? true : false)
                }
            } else {
                if (ENABLE_SCHEDULE_TIMES.includes(index)) {
                    timeArray.push(elem === 1 ? true : false)
                }
            }
        })
        return timeArray
    })
    return scheduleArrayBoolean
}

const scheduleArrayToStringForMs = function (scheduleArray: boolean[][], campaignType: number) {
    const scheduleArrayNumber = scheduleArray.map(row => {
        let timeArray: number[] = []
        for (let i = 0; i < 24; i++) {
            if (campaignType === CAMPAIGN_TYPE.MS) {
                if (!ENABLE_SCHEDULE_TIMES_MS.includes(i)) {
                    timeArray.push(0)
                } else {
                    const valueIndex = ENABLE_SCHEDULE_TIMES_MS.indexOf(i)
                    timeArray.push(row[valueIndex] === true ? 1 : 0)
                }
            } else {
                if (!ENABLE_SCHEDULE_TIMES.includes(i)) {
                    timeArray.push(0)
                } else {
                    const valueIndex = ENABLE_SCHEDULE_TIMES.indexOf(i)
                    timeArray.push(row[valueIndex] === true ? 1 : 0)
                }
            }
        }
        return timeArray
    })
    const scheduleStringNumber = JSON.stringify(scheduleArrayNumber)
    return scheduleStringNumber
}

const INIT_CAMPAIGN: Campaign = {
    id: INIT_NUMBER,
    createdAt: INIT_STR,
    updatedAt: INIT_STR,
    lastUpdateUserId: INIT_NUMBER,
    adAccountId: INIT_NUMBER,
    name: INIT_STR,
    status: 3,
    campaignType: 1,
    budgetLimitDaily: null,
    schedule: scheduleArrayToStringForMs(DEFAULT_WEEK, CAMPAIGN_TYPE.MS),
    startDate: moment().add(1, "days").startOf('day').format(FORMAT_YYYY_MM_DD_HHmm),
    endDate: moment().endOf('month').endOf('day').format(FORMAT_YYYY_MM_DD_HHmm),
    cpa: null,
    billingType: -1,
    /*　リリース時期未定のため、無効化しておく。
        excludingAudiences: [],
    */
    trackingPoints: [],
    lastUpdatedVer: INIT_STR,
}

/*
    画面名：キャンペーン作成・編集（MS）
 */
const CampaignCreateEditService: React.FC<{
    platformAccountId: number,
    campaignId: number,
    listReloadFunc?: any,
}> = ({platformAccountId, campaignId, listReloadFunc}) => {

    // useRef
    const processing = useRef(false);

    // Style
    const classes = apollo_useStyles();

    // history
    const history = useHistory();

    // useContext
    const {state: apolloContex} = React.useContext(ApolloContext);
    const {data, setmsg} = React.useContext(ApolloMessage);

    // useState
    const [msCampaign, setMsCampaign] = useState<Campaign>(INIT_CAMPAIGN)

    const [schedule, setSchedule] = useState(scheduleStringToArrayForMs(msCampaign.schedule, msCampaign.campaignType))
    const [openSchedule, setOpenSchedule] = useState<boolean>(false)

    const [enableEditStartDate, setEnableEditStartDate] = useState(true)

    /* 初回リリース時期未定のため、無効化する
        const [heraAudiences, setHeraAudiences] = useState<Audience[]>([])
    */
    const [heraSetPoints, setHeraSetPoints] = useState<SetPoint[]>([])
    const [tmpSetPoints, SetTmpSetPoints] = useState<SetPoint[]>([]);
    const [tmpDeletedSetPoints, SetTmpDeletedSetPoints] = useState<SetPoint[]>([]);

    const [endDateInputType, setEndDateInputType] = useState(END_DATE_TYPE.MANUAL_DATE);

    const endDateBeforeEdit = useRef(BLANK);
    const beforeEditRecord = useRef<LogRecord | null>(null);

    const isExistsNotActiveSetPoint = useRef<boolean>(false);
    const isExistsDeletedSetPoint = useRef<boolean>(false);
    const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)

    // register
    const {
        register,
        handleSubmit,
        control,
        errors,
        formState,
        setError,
        setValue
    } = useForm({reValidateMode: 'onBlur'});

    // etc
    const trackerId = apolloContex.current.trackerId
    /* 初回リリース時期未定のため、無効化する
        const options_audience = heraAudiences?.map(audience => ({value: audience.ID, label: audience.name}))
    */
    const options_point = heraSetPoints?.map(setPoints => ({value: setPoints.ID, label: `${setPoints.ID}_${setPoints.name}`}))
    //配信開始日の変更可否チェック

    // function
    const goback = () => {
        campaignId === CREATE_PROC ?
            history.push(`${isummary_path}`) :
            listReloadFunc && listReloadFunc()
    };

    // useEffect
    useEffect(() => {
        // トラッカーIDが無い場合
        if (!trackerId) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: MSG.ERR_TRACKER_ID
                }
            });
            return
        }

        const fetchMsCampaign = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaign_path}/${platformAccountId}/${campaignId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        let data: Campaign = response.data.result
                        const tmpEndDate = data.endDate ? data.endDate.replace(DATE_TIME_SUFFIX, BLANK) : BLANK
                        if (!data.cpa) {
                            data.cpa = null
                        }
                        if (new Date(MAX_END_DATE).getTime() === new Date(data.endDate?.replace(DATE_TIME_SUFFIX, BLANK) ?? BLANK).getTime()) {
                            data.endDate = BLANK
                            setEndDateInputType(END_DATE_TYPE.MAX_DATE)
                        }
                        const localEnableEditStartDate =
                            (campaignId !== CREATE_PROC && msCampaign.startDate && moment().add(1, 'day').startOf('day').diff(moment(data.startDate)) > 0) ? false : true;
                        setEnableEditStartDate(localEnableEditStartDate)

                        const startData = data.startDate.replace(DATE_TIME_SUFFIX, BLANK);
                        const endData = data.endDate ? data.endDate.replace(DATE_TIME_SUFFIX, BLANK) : BLANK

                        endDateBeforeEdit.current = moment(endData).format(FORMAT_YYYY_MM_DD)

                        const tmpMsCampaign = {
                            ...data,
                            startDate: startData,
                            endDate: endData,
                        }

                        setMsCampaign(tmpMsCampaign)
                        setSchedule(scheduleStringToArrayForMs(data.schedule,data.campaignType))

                        beforeEditRecord.current = {
                            data: {
                                ...cloneDeep(tmpMsCampaign),
                                startDate: `${moment(tmpMsCampaign.startDate).format(FORMAT_START_DAY_YYYY_MM_DD_HHmmss)}${DATE_TIME_SUFFIX}`,
                                endDate: tmpEndDate
                            }
                        }

                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_CAMPAIGN}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_CAMPAIGN}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        /* 初回リリース時期未定のため、無効化する
            const fetchAudience = async () => {
                const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_audiences_path}/${trackerId}`
                await axios.get(url, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${state.accesstoken}`,
                    }
                })
                    .then((response) => {
                        setHeraAudiences(response.data.result)
                    })
                    .catch(() => {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "error",
                                message: "配信オーディエンス除外設定のデータ取得に失敗しました。"
                            }
                        });
                    })
            }
    */

        const fetchSetPoint = async () => {
            const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}`
            await ApolloAxios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${apolloContex.accesstoken}`,
                }
            })
                .then((response) => {
                    if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`
                            }
                        });
                    } else if (response.data.result) {
                        SetTmpSetPoints(response.data.result)
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`
                        }
                    });
                })
        }

        const fetchDeletedSetPoints = async () => {
            // トラッカーIDが無い or 新規作成の場合
            if (!trackerId) return;
            const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_account_path}/${apolloContex.current.accountId}/setpoints/deleted`;
            await ApolloAxios.get(url).then(response => {
                if (response.status !== 200) {
                    return Promise.reject({
                        open: true,
                        type: getResultType(response.status === 400 ? -1 : -9),
                        errmsg: `${MSG.ERR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`,
                    });
                }

                if(response.data?.result) SetTmpDeletedSetPoints(response.data.result);
            }).catch(err => {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: `${MSG.ERR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`
                    }
                });
            });
        }

        const fetchAll = async () => {
            setmsg({
                type: "loading",
                payload: {
                    ...data,
                    loading: true
                }
            })

            await Promise.all(
                campaignId === CREATE_PROC
                    ? [/*fetchAudience(),リリース時期未定の為、無効化する。*/
                        fetchSetPoint()]
                    : [fetchMsCampaign()/*, fetchAudience()　リリース時期未定の為、無効化する。*/, fetchSetPoint(), fetchDeletedSetPoints()]
            ).finally(() => {
                setmsg({
                    type: "loading",
                    payload: {
                        ...data,
                        loading: false
                    }
                })
            })
        }
        fetchAll();
    }, [])

    useEffect(() => {
        const list: SetPoint[] = [];
        tmpSetPoints?.map((v: SetPoint) => {
            const data: SetPoint = {
                ...v,
                name: v.isActive ? v.name : `${v.name}（停止中）`
            }
            list.push(data)
        })
        if(msCampaign.id === INIT_NUMBER) {
            if(list.length > 0) setHeraSetPoints(list);
            return;
        }
        const deletedList: SetPoint[] = [];
        msCampaign.trackingPoints?.map((v) => {
           const setPoints = tmpDeletedSetPoints.filter((d) => d.ID === v.trackingPointId);
           if(setPoints?.length > 0) {
               const data = setPoints[0];
               if(data.name?.match(/（削除済み）$/) === null) {
                   data.name = `${data.name}（削除済み）`;
               }
               deletedList.push(data);
           }
        });

        const mixList = list.concat(deletedList);
        setHeraSetPoints(mixList);
    }, [tmpSetPoints, tmpDeletedSetPoints, msCampaign.id]);

    const handleOpenConfirm = () => {
        if (!openConfirmDialog) setOpenConfirmDialog(true)
    }

    const handleCloseConfirm = () => {
        if (openConfirmDialog) setOpenConfirmDialog(false)
    }

    const onSubmit = handleSubmit(async (formData: any) => {

        let hasError = false;
        if (msCampaign.billingType === BILLING_TYPE.CPM && (msCampaign.budgetLimitDaily && msCampaign.budgetLimitDaily < MAX_BUDGET_LIMIT_DAILY_AMOUNT)) {
            setError("budgetLimitDaily", {type: "manual", message: `課金種別が"CPM"の場合、￥1,000以上を入力して下さい。`})
            hasError = true;
        }

        /*　リリース時期未定のため、無効化しておく。
        if (msCampaign.excludingAudiences.length > MAX_EXCLUDING_AUDIENCES_NUM) {
                    setError("excludingAudiences", {type: "manual", message: '配信オーディエンス除外設定が4つ以上指定されています。3つ以下で設定ください。'})
                    hasError = true;
                }*/

        if (msCampaign.trackingPoints.length > MAX_TRACKING_POINTS_NUM) {
            hasError = true;
            setError("trackingPoints", {type: "manual", message: '測定ポイント設定が6つ以上指定されています。5つ以下で設定ください。'})

        }

        if (endDateInputType === END_DATE_TYPE.MANUAL_DATE && moment(msCampaign.endDate, FORMAT_YYYY_MM_DD_HHmm) < moment(msCampaign.startDate, FORMAT_YYYY_MM_DD_HHmm)) {
            setError("endDate", {type: "manual", message: '配信終了日は、配信開始日以降を入力してください。'})
            return
            hasError = true;
        }

        if (schedule.flatMap((elem: boolean) => elem).filter((elem: boolean) => elem).length === 0) {
            setmsg({
                type: "setMessage",
                payload: {
                    ...data,
                    open: true,
                    type: "error",
                    message: "配信スケジュールが未選択です。配信スケジュールは1つ以上選択してください。"
                }
            });
            hasError = true;
        }

        if (hasError) return

        isExistsNotActiveSetPoint.current = false;
        isExistsDeletedSetPoint.current = false;
    
        if (trackerId) {
            const localValSetPoint = await getTrackerSetPoint(trackerId);
            if (localValSetPoint.message !== "") {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: localValSetPoint.message
                    }
                });
                return
            }
            if (localValSetPoint.result) {
                for (const trackingPoints of msCampaign.trackingPoints) {
                    const val = localValSetPoint?.result?.find(v => v.ID === trackingPoints.trackingPointId)
                    if (val?.isActive === false) {
                        isExistsNotActiveSetPoint.current =true;
                        break;
                    }
                }
            }
        }

        if (campaignId !== CREATE_PROC) {
            const localValDeletedSetPoint = await getAccountDeletedSetPoints(apolloContex.current.accountId);
            if (localValDeletedSetPoint.message !== "") {
                setmsg({
                    type: "setMessage",
                    payload: {
                        ...data,
                        open: true,
                        type: "error",
                        message: localValDeletedSetPoint.message
                    }
                });
                return
            }
            if (localValDeletedSetPoint.result) {
                for (const trackingPoints of msCampaign.trackingPoints) {
                    const val = localValDeletedSetPoint?.result?.find(v => v.ID === trackingPoints.trackingPointId)
                    if (val) {
                        isExistsDeletedSetPoint.current = true;
                        break;
                    }
                }
            }
        }

        if (isExistsNotActiveSetPoint.current || isExistsDeletedSetPoint.current) {
            handleOpenConfirm()
            return;
        }

        await handleSubmitExecute();
    });

    const handleSubmitExecute = async() => {

        if (formState.isSubmitting) return;
        if (processing.current) return;
        let isSuccess = false;

        const startDateConverted = `${moment(msCampaign.startDate).format(FORMAT_START_DAY_YYYY_MM_DD_HHmmss)}${DATE_TIME_SUFFIX}`;
        const endDateConverted = endDateInputType === END_DATE_TYPE.MAX_DATE ? `${moment(MAX_END_DATE).format(FORMAT_END_DAY_YYYY_MM_DD_HHmmss)}${DATE_TIME_SUFFIX}`
            : `${moment(msCampaign.endDate).format(FORMAT_END_DAY_YYYY_MM_DD_HHmmss)}${DATE_TIME_SUFFIX}`;

        const scheduleArrayConverted = scheduleArrayToStringForMs(schedule, msCampaign.campaignType);

        const editLogInfo = createUserLog(
            apolloContex,
            "メール広告",
            "キャンペーン",
            campaignId === CREATE_PROC ? CREATE_PROC : EDIT_PROC,
            campaignId === CREATE_PROC ? "キャンペーン（MS）作成" : "キャンペーン（MS）編集",
            beforeEditRecord.current,
            {
                data: {
                    ...cloneDeep(msCampaign),
                    schedule: scheduleArrayConverted,
                    startDate: startDateConverted,
                    endDate: endDateConverted,
                },
            },
            {
                status: options_state_edit_ms,
                campaignType: options_ms_campaign_type,
                billingType: options_ms_billing_type,
                trackingPoints: options_point,
            },
            String(msCampaign.id || BLANK),
            msCampaign.name,
            BLANK,
            BLANK,
        )
        ApolloEventRecord({...editLogInfo, logType: "execute"})

        processing.current = true;

        if (campaignId === CREATE_PROC) {

            const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_campaign_path}`

            const campaignCreateRequest: CampaignCreate = {
                adAccountId: platformAccountId,
                campaignName: msCampaign.name,
                campaignStatus: msCampaign.status,
                chargeType: Number(msCampaign.billingType),
                campaignType: msCampaign.campaignType,
                targetCpa: Number(msCampaign.cpa) ? Number(msCampaign.cpa) : null,
                distributionStart: startDateConverted,
                distributionEnd: endDateConverted,
                cpd: Number(msCampaign.budgetLimitDaily),
                distributionScd: scheduleArrayConverted,
                /*　リリース時期未定のため、無効化しておく。
                                excludingAudience: msCampaign.excludingAudiences,
                */
                campaignTrackingPoint: msCampaign.trackingPoints,
                userId: apolloContex.userprofile.userId.toString(),
            }

            let registedId = BLANK

            await ApolloAxios.post(
                url,
                campaignCreateRequest,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        registedId = response.data.registedId?.toString() ?? BLANK
                        isSuccess = true;
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "success",
                                message: MSG.SUCCESS_POST_CAMPAIGN
                            }
                        });
                        goback()
                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_POST_CAMPAIGN}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_POST_CAMPAIGN}${err?.errmsg ?? BLANK}`
                        }
                    });
                }).finally(() => {
                    processing.current = false;
                    const eventRecords: LogData = {
                        ...editLogInfo,
                        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                        targetID: registedId,
                        targetName: msCampaign.name,
                        logType: "result",
                        result: isSuccess ? "成功" : "失敗",
                        campaignName: msCampaign.name,
                        campaignID: registedId,
                    }
                    ApolloEventRecord(eventRecords)
                });
        } else {

            if (msCampaign.campaignType == CAMPAIGN_TYPE.RTM) {
                processing.current = false;
                setmsg({
                    type: "setMessage",
                    payload: {
                      ...data,
                      open: true,
                      type: "error",
                      message: `${"リアルタイムメッセージSのキャンペーンは変更できません。"}`,
                    }
                  });
                return;
            }

            const url = `${process.env.REACT_APP_API_ENDPOINT}${put_ms_campaign_path}`
            const msAdCampaignUpdate: CampaignUpdate = {
                adAccountId: platformAccountId,
                campaignId: campaignId,
                campaignName: msCampaign.name,
                campaignStatus: msCampaign.status,
                distributionStart: startDateConverted,
                distributionEnd: endDateConverted,
                cpd: Number(msCampaign.budgetLimitDaily),
                targetCpa: Number(msCampaign.cpa) ? Number(msCampaign.cpa) : null,
                distributionScd: scheduleArrayConverted,
                /* リリース時期未定のため、無効化しておく。
                excludingAudience: msCampaign.excludingAudiences,*/
                campaignTrackingPoint: msCampaign.trackingPoints,
                userId: apolloContex.userprofile.userId.toString(),
                lastUpdatedVer: msCampaign.lastUpdatedVer,
            }

            await ApolloAxios.put(
                url,
                msAdCampaignUpdate,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apolloContex.accesstoken}`,
                    }
                })
                .then((response) => {
                    if (response.data.resultcode === RESULT_KBN.SUCCESS) {
                        isSuccess = true;
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "success",
                                message: MSG.SUCCESS_PUT_CAMPAIGN
                            }
                        });
                        goback()
                    } else if (response.data.resultcode === RESULT_KBN.ERROR) {
                        setmsg({
                            type: "setMessage",
                            payload: {
                                ...data,
                                open: true,
                                type: "error",
                                message: `${MSG.ERR_PUT_CAMPAIGN}${response?.data?.message ?? BLANK}`
                            }
                        });
                    }
                })
                .catch((err) => {
                    setmsg({
                        type: "setMessage",
                        payload: {
                            ...data,
                            open: true,
                            type: "error",
                            message: `${MSG.ERR_PUT_CAMPAIGN}${err?.errmsg ?? BLANK}`
                        }
                    });
                }).finally(() => {
                    processing.current = false;
                    const eventRecords: LogData = {
                        ...editLogInfo,
                        targetID: msCampaign.id.toString(),
                        targetName: msCampaign.name,
                        logType: "result",
                        result: isSuccess ? "成功" : "失敗",
                    }
                    ApolloEventRecord(eventRecords)
                });
        }
    }

    return (
        <React.Fragment>
            {campaignId !== 0 ?
                <Typography variant="h6">
                    キャンペーン編集：{msCampaign.name}
                </Typography> : <></>
            }

            <form noValidate onSubmit={onSubmit}>
                <Card className={classes.root} square variant="outlined">
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <ApolloBasicTextField
                                    id="id"
                                    label="メール広告キャンペーンID"
                                    value={campaignId === CREATE_PROC ? "自動採番" : campaignId}
                                    disabled={true}
                                    error={errors.id}
                                    required={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicTextField
                                    id="name"
                                    label="キャンペーン名"
                                    value={msCampaign.name}
                                    inputRef={register({
                                        required: "必須入力項目です。",
                                        maxLength: {
                                            value: 255,
                                            message: "255文字以内で入力して下さい。"
                                        },
                                        validate: (e: string) => {
                                            const errorMessage = checkInvalidTabCharsForName(e)
                                            if(errorMessage) {
                                                return errorMessage
                                            }},
                                    })}
                                    error={errors.name}
                                    required={true}
                                    setState={(e: any) => setMsCampaign({
                                        ...msCampaign,
                                        name: e
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicSelect
                                    id="status"
                                    label="ステータス"
                                    options={campaignId === CREATE_PROC
                                        ? options_state_edit_ms.filter(value => value.value !== ARCHIVE_VALUE_NO)
                                        : options_state_edit_ms}
                                    value={msCampaign.status}
                                    control={control}
                                    errors={errors}
                                    setState={(e: any) => setMsCampaign({
                                        ...msCampaign,
                                        status: e
                                    })}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicSelect
                                    id="campaignType"
                                    label={(campaignId !== CREATE_PROC || msCampaign.campaignType !== CAMPAIGN_TYPE.RTM )? "キャンペーン種別" :
                                     "キャンペーン種別 ※「キャンペーン種別：リアルタイムメッセージS」は2024年3月で配信を終了しました。"}
                                    options={campaignId !== CREATE_PROC? options_ms_campaign_type:options_select_ms_campaign_type}
                                    value={msCampaign.campaignType}
                                    control={control}
                                    errors={errors}
                                    disabled={campaignId !== CREATE_PROC}
                                    setState={(e: any) => {
                                        setSchedule(scheduleStringToArrayForMs(msCampaign.schedule,e))
                                        setMsCampaign({
                                            ...msCampaign,
                                            campaignType: e,
                                            schedule: scheduleArrayToStringForMs(scheduleStringToArrayForMs(msCampaign.schedule,e), e),
                                            billingType: 0
                                        })
                                    }
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicTextField
                                    id="budgetLimitDaily"
                                    label="日予算額"
                                    type="text"
                                    value={msCampaign.budgetLimitDaily || ""}
                                    inputRef={register({
                                        required: "必須入力項目です。",
                                        validate: (e: number) => {
                                            if(e < 1) {
                                                return "1以上を入力して下さい。"
                                            }
                                            if(e > 999999999999) {
                                                return "999999999999以内を入力して下さい。"
                                            }
                                        },
                                    })}
                                    error={errors.budgetLimitDaily}
                                    required={true}
                                    setState={(e: any) => setMsCampaign({
                                        ...msCampaign,
                                        budgetLimitDaily: Number(e)
                                    })}
                                    unNegative={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" gutterBottom component="div">
                                    掲載スケジュール
                                </Typography>
                                <IconButton aria-label="expand row" size="small"
                                            onClick={() => {
                                                setOpenSchedule(!openSchedule)
                                            }}>
                                    {openSchedule ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                                </IconButton>
                                <Collapse in={openSchedule} timeout="auto" unmountOnExit>
                                    <Paper style={{overflow: 'auto'}} square variant="outlined">
                                        <TargetTime
                                            key={msCampaign.id === 0 ? "Loaded" : "Loading"}
                                            week={schedule}
                                            onChange={(week: any) => {
                                                setMsCampaign({
                                                    ...msCampaign,
                                                    schedule: scheduleArrayToStringForMs(week, msCampaign.campaignType)
                                                })
                                                setSchedule(week)}}
                                            enableTimes={msCampaign.campaignType === CAMPAIGN_TYPE.MS? ENABLE_SCHEDULE_TIMES_MS: ENABLE_SCHEDULE_TIMES}
                                        />
                                    </Paper>
                                </Collapse>
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicDistributionDate
                                    startDate={{
                                        id: "startDate",
                                        value: msCampaign.startDate,
                                        inputRef: register({
                                            validate: (value) => {
                                                if (!enableEditStartDate) return
                                                if (value === "") {
                                                    return "必須入力項目です。"
                                                }
                                                const nextDay = moment().add(1, 'day').startOf('day');
                                                const inputDay = moment(value, "YYYY-MM-DD");
                                                if (inputDay.diff(nextDay) < 0) {
                                                    return '翌日以降を指定してください。'
                                                }

                                            },
                                        }),
                                        errors: errors.startDate,
                                        disabled: !enableEditStartDate,
                                        setState: (e: any) => setMsCampaign(
                                            {...msCampaign, startDate: e}
                                        ),
                                        dateOnly: true,
                                    }}
                                    endDate={{
                                        id: "endDate",
                                        value: msCampaign.endDate,
                                        inputType: endDateInputType,
                                        inputRef: register({
                                            validate: (value) => {
                                                if (endDateInputType === 1) return
                                                if (value === "") {
                                                    return "必須入力項目です。"
                                                }

                                                const inputDay = moment(value, "YYYY-MM-DDTHH:mm");

                                                if (endDateBeforeEdit.current != value) {
                                                    const current = moment().startOf('day');
                                                    if (msCampaign.campaignType === CAMPAIGN_TYPE.RTM && inputDay.diff(current.add(1, 'day')) < 0) {
                                                        return '翌日以降を指定してください。'
                                                    } else if (msCampaign.campaignType === CAMPAIGN_TYPE.MS && inputDay.diff(current.add(2, 'day')) < 0) {
                                                        return '翌々日以降を指定してください。'
                                                    }
                                                }
                                            },
                                        }),
                                        errors: errors.endDate,
                                        setInputType: setEndDateInputType,
                                        setState: (e: any) => {
                                            setEndDateInputType(END_DATE_TYPE.MANUAL_DATE)
                                            setMsCampaign(
                                                {...msCampaign, endDate: e}
                                            )
                                        },
                                        inputProps: {
                                            disabled: endDateInputType === END_DATE_TYPE.MAX_DATE,
                                            style: endDateInputType === END_DATE_TYPE.MAX_DATE ? {color: `rgba(0, 0, 0, 0.38)`} : {},
                                        },                                        
                                        dateOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicTextField
                                    id="cpa"
                                    label="目標獲得単価"
                                    type="text"
                                    value={msCampaign.cpa || ""}
                                    inputRef={register({
                                        validate: (e: number) => {
                                            if(!e) return
                                            if(e < 1) {
                                                return "1以上を入力して下さい。"
                                            }
                                            if(e > 999999999999) {
                                                return "999999999999以内を入力して下さい。"
                                            }
                                        },
                                    })}
                                    error={errors.cpa}
                                    setState={(e: any) => setMsCampaign({
                                        ...msCampaign,
                                        cpa: Number(e)
                                    })}
                                    unNegative={true}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ApolloBasicSelect
                                    id="billingType"
                                    label="課金種別"
                                    options={msCampaign.campaignType === CAMPAIGN_TYPE.RTM ? options_ms_billing_type.filter(value => value.label === options_ms_billing_type[1].label) : options_ms_billing_type}
                                    value={msCampaign.billingType}
                                    control={control}
                                    disabled={campaignId !== CREATE_PROC}
                                    rules={{
                                        required: "必須入力項目です。",
                                    }}
                                    errors={errors}
                                    setState={(e: any) => setMsCampaign({
                                        ...msCampaign,
                                        billingType: e
                                    })}
                                    setValue={(name: string, value: any) => setValue(name, value)}
                                />
                            </Grid>
                            {/*<Grid item xs={12}>
                                <ApolloBasicSelect
                                    id="excludingAudiences"
                                    label="配信オーディエンス除外設定"
                                    options={options_audience}
                                    value={msCampaign.excludingAudiences.map((elem: any) => elem.audienceId)}
                                    isMulti={true}
                                    control={control}
                                    errors={errors}
                                    menuPlacement="top"
                                    rules={{
                                        required: "必須入力項目です。",
                                    }}
                                    closeMenuOnSelect={false}
                                    setState={(e: any) => {
                                        const setVal = e ? e.map((target: any) => {
                                            return {audienceId: target.value}
                                        }) : []
                                        setMsCampaign({
                                                ...msCampaign,
                                                excludingAudiences: setVal

                                            }
                                        )
                                    }}
                                    setValue={(name: string, value: any) => setValue(name, value)}
                                />
                            </Grid>リリース時期未定のため、無効化しておく。 */}
                            <Grid item xs={12}>
                                <ApolloBasicSelect
                                    id="trackingPoints"
                                    label="測定ポイント設定"
                                    options={options_point}
                                    value={msCampaign.trackingPoints.map((elem: any) => elem.trackingPointId)}
                                    control={control}
                                    isMulti={true}
                                    menuPlacement="top"
                                    closeMenuOnSelect={false}
                                    errors={errors}
                                    rules={{}}
                                    setState={(e: any) => {
                                        const setVal = e ? e.map((target: any) => {
                                            return {trackingPointId: target.value}
                                        }) : []
                                        setMsCampaign({
                                            ...msCampaign,
                                            trackingPoints: setVal

                                        })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions className={classes.cardaction}>
                        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                onClick={onSubmit}
                                className={classes.button}
                                disabled={formState.isSubmitting || processing.current}
                            >
                                {campaignId === CREATE_PROC ? "作成" : "更新"}
                            </Button>
                        </ApolloUserProfileAuth>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={e => goback()}
                            className={classes.button}
                            disabled={formState.isSubmitting || processing.current}
                        >
                            戻る
                        </Button>
                    </CardActions>
                </Card>
            </form>
            <ApolloDialog open={openConfirmDialog} setOpen={setOpenConfirmDialog}>
                <ApolloConfirmNotActiveDialog
                    isExistsNotActiveSetPoint={isExistsNotActiveSetPoint.current}
                    isExistsDeletedSetPoint={isExistsDeletedSetPoint.current}
                    handleSave={handleSubmitExecute}
                    handleClose={handleCloseConfirm}
                />
            </ApolloDialog>
        </React.Fragment>
    )
        ;
};

const createUserLog = (
    apolloContex: any,
    menu: string,
    category: string,
    actionType: number,
    displayName: string,
    beforeInfo: LogRecord | null,
    afterInfo: LogRecord,
    optionMaster: {
        status: any,
        campaignType: any,
        billingType: any,
        trackingPoints: any,
    },
    campaignId?: string,
    campaignName?: string,
    adGroupId?: string,
    adGroupName?: string,
) => {

    const beforeData = beforeInfo?.data ?? null
    const afterData = afterInfo?.data
    const items: ItemList[] = [
        createUserLogItemListFromString("キャンペーン名", "name", beforeData, afterData),
        createUserLogItemListFromOptionValue("ステータス", "status", beforeData, afterData, optionMaster.status),
        createUserLogItemListFromOptionValue("キャンペーン種別", "campaignType", beforeData, afterData, optionMaster.campaignType),
        createUserLogItemListFromNumber("日額予算", "budgetLimitDaily", beforeData, afterData),
        createUserLogItemListFromSchedules("掲載スケジュール", "schedule", beforeData, afterData, SCHEDULES_WEEKS_MS),
        createUserLogItemListFromDate("掲載期間_開始", "startDate", beforeData, afterData, "YYYY-MM-DD"),
        createUserLogItemListFromDate("掲載期間_終了", "endDate", beforeData, afterData, "YYYY-MM-DD"),
        createUserLogItemListFromNumber("目標獲得単価", "cpa", beforeData, afterData),
        createUserLogItemListFromOptionValue("課金種別", "billingType", beforeData, afterData, optionMaster.billingType),
        createUserLogItemListFromOptionValuesTrackingMs("測定ポイント設定", "trackingPoints", beforeData, afterData, optionMaster.trackingPoints)
    ]

    const retObj = createLogDate(
        apolloContex,
        menu,
        category,
        actionType === CREATE_PROC ? "作成" : "更新",
        displayName,
        items,
        campaignId,
        campaignName,
        adGroupId,
        adGroupName,
    )

    return retObj
}


export default CampaignCreateEditService;
